export default "__VITE_ASSET__BG8O_ECT__"